import { PaintedScene } from '../PaintedScene';

export const ABANDONED_LOOM_PHASER_KEY = 'AbandonedLoomScene' as const;
export const ABANDONED_LOOM_MANIFEST_KEY = 's-213-abandoned-loom' as const;

export class AbandonedLoomScene extends PaintedScene {
  constructor() {
    super(ABANDONED_LOOM_PHASER_KEY, ABANDONED_LOOM_MANIFEST_KEY);
  }
}
